import { Link } from "react-router-dom";
import { navItems, siteInfo } from "@/mocks/site";

const sectionLinks = [
  { label: "剧集观察", path: "/gossip?category=剧集观察" },
  { label: "综艺幕后", path: "/gossip?category=综艺幕后" },
  { label: "音乐现场", path: "/gossip?category=音乐现场" },
  { label: "行业风向", path: "/gossip?category=行业风向" },
  { label: "平台生态", path: "/gossip?category=平台生态" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-secondary-950 text-background-100 mt-16">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-xl font-bold">
                黑
              </span>
              <span className="font-heading text-2xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-100/80 mb-4">
              {siteInfo.description}
            </p>
            <p className="text-xs text-secondary-200/70">{siteInfo.updateTime}</p>
          </div>

          <nav aria-label="页脚导航" className="flex flex-col gap-3">
            <h2 className="font-heading text-base font-semibold text-background-50 mb-1">网站导航</h2>
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-sm text-secondary-100/80 hover:text-accent-300 transition-colors w-fit"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex flex-col gap-3">
            <h2 className="font-heading text-base font-semibold text-background-50 mb-1">内容分类</h2>
            {sectionLinks.map((item) => (
              <Link
                key={item.label}
                to={item.path}
                className="text-sm text-secondary-100/80 hover:text-accent-300 transition-colors w-fit"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-secondary-200/70">
          <p>© {year} {siteInfo.name} · 内容仅作行业观察与资讯整理</p>
          <div className="flex items-center gap-4">
            <a href={`mailto:${siteInfo.email}`} className="hover:text-accent-300 transition-colors">
              {siteInfo.email}
            </a>
            <Link to="/faq" className="hover:text-accent-300 transition-colors">
              内容原则
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}